import { DadosComponentesProjetoSaida } from 'models/Viabilidade/DadosComponenteProjetoSaida'
import NumberFormat from 'react-number-format'
import {
  TableCellBold,
  TableCellBoldAlignRight,
  TableCellBoldBorda,
  TableCellBoldBordaCentralizado,
  TableCellBoldCentralizado,
  TableCellBorda,
  TableCellValor,
  TableCellValorBorda,
  TableContainerCustomizado,
  TableLayoutFixed,
  TableRowBranca,
  TableRowVerde,
  TableRowVerdeClaro
} from '../../index.style'

const TabelaComponentesProjeto: React.FC<{ dados: DadosComponentesProjetoSaida }> = ({ dados }) => {
  const dadosTabela = [
    {
      descricao: 'Academia Coberta',
      id: 'rowAcademiaCoberta',
      nome: 'academiaCoberta',
      area: dados.academiaCobertaArea,
      valor: dados.academiaCobertaValorTotal
    },
    { descricao: 'Coworking', id: 'rowCoworking', nome: 'coworking', area: dados.coworkingArea, valor: dados.coworkingValorTotal },
    { descricao: 'Churrasqueira', id: 'rowChurrasqueira', nome: 'churrasqueira', area: dados.churrasqueiraArea, valor: dados.churrasqueiraValorTotal },
    { descricao: 'Espaço Mulher', id: 'rowEspacoMulher', nome: 'espacoMulher', area: dados.espacoMulherArea, valor: dados.espacoMulherValorTotal },
    { descricao: 'Espaço Kids', id: 'rowEspacoKids', nome: 'espacoKids', area: dados.espacoKidsArea, valor: dados.espacoKidsValorTotal },
    {
      descricao: 'Garrafão de Basquete',
      id: 'rowGarrafaoBasquete',
      nome: 'garrafaoBasquete',
      area: dados.garrafaoBasqueteArea,
      valor: dados.garrafaoBasqueteValorTotal
    },
    { descricao: 'Guarita', id: 'rowGuarita', nome: 'guarita', area: dados.guaritaArea, valor: dados.guaritaValorTotal },
    { descricao: 'Lavanderia', id: 'rowLavanderia', nome: 'lavanderia', area: dados.lavanderiaArea, valor: dados.lavanderiaValorTotal },
    { descricao: 'Piscina', id: 'rowPiscina', nome: 'piscina', area: dados.piscinaArea, valor: dados.piscinaValorTotal },
    { descricao: 'Pet Care', id: 'rowPetCare', nome: 'petCare', area: dados.petCareArea, valor: dados.petCareValorTotal },
    { descricao: 'Pet Place', id: 'rowPetPlace', nome: 'petPlace', area: dados.petPlaceArea, valor: dados.petPlaceValorTotal },
    { descricao: 'Playground', id: 'rowPlayground', nome: 'playground', area: dados.playgroundArea, valor: dados.playgroundValorTotal },
    { descricao: 'Quadra', id: 'rowQuadra', nome: 'quadra', area: dados.quadraArea, valor: dados.quadraValorTotal },
    {
      descricao: 'Quadra Coberta com Alambrado',
      id: 'rowQuadraCobertaAlambrado',
      nome: 'quadraCobertaAlambrado',
      area: dados.quadraCobertaAlambradoArea,
      valor: dados.quadraCobertaAlambradoValorTotal
    },
    {
      descricao: 'Salão de Festas Gourmet',
      id: 'rowSalaoFestasGourmet',
      nome: 'salaoFestasGourmet',
      area: dados.salaoFestasGourmetArea,
      valor: dados.salaoFestasGourmetValorTotal
    },
    { descricao: 'Salão de Jogos', id: 'rowSalaoJogos', nome: 'salaoJogos', area: dados.salaoJogosArea, valor: dados.salaoJogosValorTotal },
    { descricao: 'Sauna', id: 'rowSauna', nome: 'sauna', area: dados.saunaArea, valor: dados.saunaValorTotal },
    { descricao: 'SPA', id: 'rowSpa', nome: 'spa', area: dados.spaArea, valor: dados.spaValorTotal },
    { descricao: 'Vestiário', id: 'rowVestiario', nome: 'vestiario', area: dados.vestiarioArea, valor: dados.vestiarioValorTotal }
  ]

  const valorTotal = dadosTabela.reduce((total, componenteProjeto) => total + (componenteProjeto.valor as number), 0)

  return (
    <TableContainerCustomizado>
      <TableLayoutFixed data-cy="tableComponentesProjeto">
        <TableRowVerdeClaro>
          <TableCellBoldBorda>Componentes de Projeto</TableCellBoldBorda>
          <TableCellBoldBordaCentralizado>Área (m²)</TableCellBoldBordaCentralizado>
          <TableCellBoldCentralizado>Valor total para esta obra (R$)</TableCellBoldCentralizado>
        </TableRowVerdeClaro>
        {dadosTabela
          .filter((f) => f.area > 0)
          .map((componenteProjeto) => (
            <TableRowBranca key={componenteProjeto.id} data-cy={componenteProjeto.id}>
              <TableCellBorda>{componenteProjeto.descricao}</TableCellBorda>
              <TableCellValorBorda data-cy={'campo' + componenteProjeto.nome + 'Area'}>
                <NumberFormat
                  value={componenteProjeto.area}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </TableCellValorBorda>
              <TableCellValor data-cy={'valor' + componenteProjeto.nome}>
                <NumberFormat
                  value={componenteProjeto.valor}
                  displayType="text"
                  thousandSeparator="."
                  decimalSeparator=","
                  allowEmptyFormatting={true}
                  defaultValue="-"
                  fixedDecimalScale={true}
                  decimalScale={2}
                />
              </TableCellValor>
            </TableRowBranca>
          ))}
        <TableRowVerde>
          <TableCellBold>Valor Total (R$)</TableCellBold>
          <TableCellBold></TableCellBold>
          <TableCellBoldAlignRight>
            <NumberFormat
              value={valorTotal}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              fixedDecimalScale={true}
              decimalScale={2}
            />
          </TableCellBoldAlignRight>
        </TableRowVerde>
      </TableLayoutFixed>
    </TableContainerCustomizado>
  )
}

export default TabelaComponentesProjeto
